import React from 'react';

function AddToQueue() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 44 44"
      fill="#5D6771"
    >
      <path d="M35.48 42.82H8.26a8.08 8.08 0 01-8.07-8.07V7.52a1.5 1.5 0 013 0v27.23a5.08 5.08 0 005.07 5.07h27.22a1.5 1.5 0 010 3z" />
      <path d="M39.51.79H10a2.76 2.76 0 00-2.76 2.76V33A2.76 2.76 0 0010 35.79h29.51A2.76 2.76 0 0042.27 33V3.55A2.76 2.76 0 0039.51.79zM34 20.13h-7.3v7.31a1.81 1.81 0 01-3.6 0v-7.31h-7.41a1.81 1.81 0 010-3.6h7.42v-7.4a1.81 1.81 0 013.6 0v7.4H34a1.81 1.81 0 010 3.6z" />
    </svg>
  );
}

export default AddToQueue;
